import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { EntitlementsService } from '../../Services/entitlements.service';

@Component({
  selector: 'app-entitlement-lock-banner',
  templateUrl: './entitlement-lock-banner.component.html',
  styleUrl: './entitlement-lock-banner.component.css',
  standalone: false,
})
export class EntitlementLockBannerComponent {
  @Input() entitlementKey = '';
  @Input() returnUrl = '/employee/setting';

  constructor(
    private entitlements: EntitlementsService,
    private router: Router
  ) {}

  get label(): string {
    return this.entitlements.getLabel(this.entitlementKey);
  }

  viewPlans(): void {
    void this.router.navigate(['/billings'], { queryParams: { intent: 'upgrade' } });
  }

  learnMore(): void {
    void this.router.navigate(['/feature-locked'], {
      queryParams: {
        keys: this.entitlementKey,
        returnUrl: this.returnUrl,
      },
    });
  }
}
